import { serviceRoles } from "config/access";
import { ASSESSMENT_LOGS } from "constants/routes";
import { checkAccess } from "helpers/auth";
import AssessmentLogsPage from "./container/AssessmentLogsPage";

export default function getSettingsRoute(userAuth) {
  const { account, harmony } = serviceRoles;
  const requireAuth = {
    [account.name]: [account.roles.superadmin],
    [harmony.name]: [harmony.roles.admin],
  };
  return {
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    path: ASSESSMENT_LOGS,
    withSidebar: true,
    withAppBar: true,
    component: AssessmentLogsPage,
  };
}
